export const CUSTOM_TOKEN_LEARN_MORE_LINK =
  'https://blog.rango.exchange/understanding-the-risks-of-using-custom-token-contract-addresses-96022308eca4';
